import React from 'react';
import { motion } from 'framer-motion';
import { Link } from 'react-router-dom';
import SafeIcon from '../../common/SafeIcon';
import * as FiIcons from 'react-icons/fi';

const { FiPalette, FiUsers, FiEye, FiSettings } = FiIcons;

const Dashboard = () => {
  const quickActions = [
    {
      title: 'Theme Settings',
      description: 'Customize website content and appearance',
      icon: FiPalette,
      link: '/admin/theme',
      color: 'bg-blue-500'
    },
    {
      title: 'User Management',
      description: 'Manage admin users and permissions',
      icon: FiUsers,
      link: '/admin/users',
      color: 'bg-green-500'
    },
    {
      title: 'Preview Site',
      description: 'View your website as visitors see it',
      icon: FiEye,
      link: '/',
      color: 'bg-purple-500'
    },
    {
      title: 'Settings',
      description: 'Configure system preferences',
      icon: FiSettings,
      link: '/admin/settings',
      color: 'bg-orange-500'
    }
  ];

  return (
    <div className="space-y-8">
      <motion.div
        initial={{ opacity: 0, y: 20 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.6 }}
      >
        <h2 className="text-3xl font-playfair text-warm-brown mb-2">Welcome to Admin Dashboard</h2>
        <p className="text-warm-brown/70">Manage your La Vie Saigon website content and settings</p>
      </motion.div>

      <div className="grid md:grid-cols-2 lg:grid-cols-4 gap-6">
        {quickActions.map((action, index) => (
          <motion.div
            key={index}
            initial={{ opacity: 0, y: 30 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.6, delay: index * 0.1 }}
          >
            <Link
              to={action.link}
              className="block bg-white rounded-xl p-6 shadow-lg hover:shadow-xl transition-shadow duration-300 group"
            >
              <div className={`${action.color} w-12 h-12 rounded-lg flex items-center justify-center mb-4 group-hover:scale-110 transition-transform duration-300`}>
                <SafeIcon icon={action.icon} className="text-white text-xl" />
              </div>
              <h3 className="text-xl font-playfair text-warm-brown mb-2">{action.title}</h3>
              <p className="text-warm-brown/70 text-sm">{action.description}</p>
            </Link>
          </motion.div>
        ))}
      </div>

      <motion.div
        initial={{ opacity: 0, y: 30 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.6, delay: 0.4 }}
        className="bg-white rounded-xl p-6 shadow-lg"
      >
        <h3 className="text-2xl font-playfair text-warm-brown mb-4">Recent Activity</h3>
        <div className="space-y-4">
          <div className="flex items-center gap-4 p-3 bg-cream rounded-lg">
            <div className="w-2 h-2 bg-green-500 rounded-full"></div>
            <p className="text-warm-brown">Website theme updated successfully</p>
            <span className="text-warm-brown/70 text-sm ml-auto">2 hours ago</span>
          </div>
          <div className="flex items-center gap-4 p-3 bg-cream rounded-lg">
            <div className="w-2 h-2 bg-blue-500 rounded-full"></div>
            <p className="text-warm-brown">New admin user created</p>
            <span className="text-warm-brown/70 text-sm ml-auto">1 day ago</span>
          </div>
          <div className="flex items-center gap-4 p-3 bg-cream rounded-lg">
            <div className="w-2 h-2 bg-purple-500 rounded-full"></div>
            <p className="text-warm-brown">Menu items updated</p>
            <span className="text-warm-brown/70 text-sm ml-auto">3 days ago</span>
          </div>
        </div>
      </motion.div>
    </div>
  );
};

export default Dashboard;